import { EpimsBaseEntityDto } from './epim-base.dto';

export class CurrencyDto extends EpimsBaseEntityDto {

    CurrencyId: string;
    CurrencyCode: string;
    CurrencyName: string;
    SubscriberId: string;
    SubscriptionUserId: string;
	DecCode: string;
    HexCode: string;
    dateCreated: Date;
   dateUpdated?: Date;
   CreatedById: string;
   ModifiedById: string;
   SiteId: string;
   Version: number;
}